<template>
  <div v-if="Array.isArray(scope.text)">
<!--    为数组情况-->
    <div v-if="scope.text.length>=2">
      <div>
        <span style="display: flex;align-items: center">
          <span>{{ scope.text[0] }}</span>
          <el-tooltip content="折叠更多" v-if="showToolTip[scope.index]">
            <span  class="moreIconDiv">
               <i class="el-icon-caret-top iconMore"  @click="openMore(scope.index)"><span class="moreTitle">折叠更多</span></i>
            </span>
          </el-tooltip>
          <el-tooltip content="展开更多" v-if="!showToolTip[scope.index]">
            <span  class="moreIconDiv">
               <i class="el-icon-caret-bottom iconMore" @click="openMore(scope.index)"><span class="moreTitle">展开更多</span></i>
            </span>
          </el-tooltip>
        </span>
        <div v-for="(con,index1) in scope.text" :key="index1" v-if="showToolTip[scope.index]">
          <div v-if="index1!==0">{{ con }}</div>
        </div>
      </div>
    </div>
    <div v-else>
      {{ scope.text[0] }}
    </div>
  </div>
  <div v-else>
<!--    为对象的情况-->
    <div v-for="(item,index1) in Object.entries(scope.text)">
      <div v-if="index1===0" style="display: flex;align-items: center" >
        <div class="time-item">
          <span class="time-label">{{ item[0] }}:</span>
          <span class="time-content">{{ item[1] }}</span>
        </div>
        <div v-if="Object.keys(scope.text).length>1">
          <el-tooltip content="折叠更多" v-if="showToolTip[scope.index]">
            <span class="moreIconDiv more_obj_div">
               <i class="el-icon-caret-top iconMore"  @click="openMore(scope.index)"><span class="moreTitle" >折叠更多</span></i>
            </span>
          </el-tooltip>
          <el-tooltip content="展开更多" v-if="!showToolTip[scope.index]">
            <span class="moreIconDiv more_obj_div">
               <i class="el-icon-caret-bottom iconMore" @click="openMore(scope.index)"><span class="moreTitle">展开更多</span></i>
            </span>

          </el-tooltip>
        </div>
      </div>
      <div v-if="index1!==0&&showToolTip[scope.index]" class="time-item">
        <span class="time-label">{{ item[0] }}:</span>
        <span>{{ item[1] }}</span>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: "WExFoldTableCell",
  props: ['scope',],
  data() {
    return {
      showToolTip: [],
    }
  },
  methods: {
    openMore(index) {
      this.$set(this.showToolTip, index, !this.showToolTip[index]);
    }
  }
}
</script>

<style scoped>
.iconMore {
  color: #4eaad4;
  cursor: pointer;
  font-size: 18px;
}

.time-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px; /* 可以根据需要调整下边距 */
}

.time-label {
  width: 120px; /* 调整标签宽度 */
  text-align: right;
}
.time-content {
  /*width: 120px; !* 调整标签宽度 *!*/
  text-align: right;
}
.moreIconDiv{
  display: flex;
}
.more_obj_div{
  margin-bottom: 10px
}
.moreTitle{
  font-size: 14px
}
</style>
